<template lang="pug">
  div
    loading(v-if="isLoading")
    bar-chart(
      v-if="!isLoading"
      :isHorizontal="false"
      :series="series"
      :categories="categories"
      yAxisTitle="Dias disponibles"
      :tooltipFormatter="tooltipFormatter"
      title="Top 10 empleados con más días disponibles"
      :showLegend="false"
      :showXlabels="true"
    )
</template>

<script>
import { apiGet } from '../../util/general';
import BarChart from '../charts/c_chart_bar';

export default {
  name: 'top_empleados_mas_dias_disponibles',
  components: {
    'bar-chart':BarChart
  },
  data () {
    return {
      // Datos para el gráfico de empleados por área
      categories: [],
      series: [
        {
          name: 'Cantidad de dias disponibles',
          data: []
        }
      ],
      isLoading:true
    };
  },
  created () {
    this.fetch();
  },
  methods: {
    tooltipFormatter (val) {
      return `${val}`;
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/kpi/top-empleados-mas-dias-disponibles', {}, function (data) {
        vm.categories = []
        vm.series[0].data = []
        for (let index = 0; index < data.lista.length; index++) {
          const element = data.lista[index];
          vm.categories.push(element.nombre)
          vm.series[0].data.push(element.cantidad)
        }
      }, function (error) {
        console.error('error', error)
      }, function () {
        vm.isLoading = false
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
/* Puedes agregar estilos personalizados aquí si es necesario */
div
  display flex
  flex-direction column
  gap 20px
  padding 20px
  box-sizing border-box
</style>



// WEBPACK FOOTER //
// c_kpi_top_empleados_mas_dias_disponibles.vue?414bdeb9